import React, { useEffect } from "react";
import * as queryString from "query-string";
import { useLocation, useHistory } from "react-router-dom";
import { ROUTE_PATHS } from "../../../constants";
import { useLazyQuery } from "@apollo/react-hooks";
import { GET_VAX_YES_VERIFY_PAY } from "../../../queries";
import { useSnackbar } from "notistack";
import { Loader } from "../../../components";
import { useTranslation } from "react-i18next";

const validatePaymentSession = (search, paymentSession) =>
  search.session_id === paymentSession.session_id ? true : false;

const paymentSession = JSON.parse(
  localStorage.getItem("PaymentSession") || "{}"
);

const VaxYesRegisterPaymentCallback = () => {
  const { search } = useLocation();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const handleError = errorMsg => {
    enqueueSnackbar(errorMsg, {
      variant: "error"
    });
    return history.push("/");
  };

  const [getVaxYesVerifyPay, { loading }] = useLazyQuery(
    GET_VAX_YES_VERIFY_PAY,
    {
      onCompleted: ({ verification }) => {
        if (
          verification &&
          verification.status &&
          verification.status === "success" &&
          verification.payment_status &&
          verification.payment_status === "complete"
        ) {
          const firstName = paymentSession.first_name;
          localStorage.removeItem("PaymentSession");

          return history.push({
            pathname: `${ROUTE_PATHS.VAXYES.REGISTER_BASE}/success`,
            state: { first_name: firstName }
          });
        } else {
          handleError(
            t(
              "vax_yes.vax_yes_register_payment_callback.api_payment_processing_error"
            )
          );
        }
      }
    }
  );

  useEffect(() => {
    if (!paymentSession.payment_checkout_session) return;

    if (validatePaymentSession(queryString.parse(search), paymentSession)) {
      getVaxYesVerifyPay({
        variables: {
          session_id: paymentSession.payment_checkout_session
        }
      });
    } else {
      handleError(
        t(
          "vax_yes.vax_yes_register_payment_callback.api_payment_validation_error"
        )
      );
    }
  }, []);

  if (loading) return <Loader />;

  return null;
};

export { VaxYesRegisterPaymentCallback };
